import { useLazyQuery } from '@apollo/client'
import { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import {
  GETLANGUAGE,
  GET_VENDOR_LIST_BY_LANGUAGE,
  VALIDATE_DIAL_IN_NUMBERS,
} from '../../../../../utils/GraphQLAPI'
import deleteButton from '../../../../images/deleteButton.svg'
import Dropdown from '../../../../../app/sharedComponent/Dropdown/Dropdown'
import { fetchGraphql } from '../../../../../utils/helper'
const callForwardQuery = `query GetVendorForwardingNumberById($getVendorForwardingNumberByIdId: String!, $langid: String!) {
  getVendorForwardingNumberById(id: $getVendorForwardingNumberByIdId, langid: $langid) {
    vendorNumber
  }
}`

const Step5 = ({
  data,
  setDialInNoValidation,
  dialInNoValidation,
  setEmailDisabled,
  emailDisabled,
  setdialInNumber,
  dialInNumber,
  updateData,
  apiDialInData,
  hasError,
}: any) => {
  const englishIdRef = useRef(null)
  const spanishIdRef = useRef(null)
  const [englishVendors, setEnglishVendors] = useState([])
  const [spanishVendors, setSpanishVendors] = useState([])
  const [selectedSpanishVendor, setSelectedSpanishVendor] = useState({ value: '' })
  const [selectedEnglishVendor, setSelectedEnglishVendor] = useState({ value: '' })
  const [selectedSpanishVendorOutbound, setSelectedSpanishVendorOutbound] = useState({ value: '' })
  const [selectedEnglishVendorOutbound, setSelectedEnglishVendorOutbound] = useState({ value: '' })
  const [getLanguageIds] = useLazyQuery(GETLANGUAGE, {
    onCompleted: (languagedata) => {
      let englishId = languagedata.getAllLanguages.filter(
        ({ languageName }: any) => languageName === 'English'
      )[0]?.id
      englishIdRef.current = englishId
      let spanishId = languagedata.getAllLanguages.filter(
        ({ languageName }: any) => languageName === 'Spanish'
      )[0]?.id

      spanishIdRef.current = spanishId
      updateData({
        liveAgentNumberEnglish: {
          ...data.liveAgentNumberEnglish,
          languageId: englishId,
        },
        outboundLiveAgentDialInNumberEng: {
          ...data.outboundLiveAgentDialInNumberEng,
          languageId: englishId,
        },
        outboundLiveAgentDialInNumberSpn: {
          ...data.outboundLiveAgentDialInNumberSpn,
          languageId: spanishId,
        },
        liveAgentNumberSpanish: {
          ...data.liveAgentNumberSpanish,
          languageId: spanishId,
        },
      })

      getVendors({
        variables: {
          languageId: englishId,
        },
      }).then(({ data: englishVendors }) => {
        setEnglishVendors(
          englishVendors.getVendorListByLanguage.map((language: any) => {
            return {
              id: language?.id,
              value: language?.vendorName,
            }
          })
        )
      })
      getVendors({
        variables: {
          languageId: spanishId,
        },
      }).then(({ data: spanishVendors }) => {
        setSpanishVendors(
          spanishVendors.getVendorListByLanguage.map((language: any) => {
            return {
              id: language?.id,
              value: language?.vendorName,
            }
          })
        )
      })
    },
    fetchPolicy: 'network-only',
  })
  const [getVendors] = useLazyQuery(GET_VENDOR_LIST_BY_LANGUAGE, {
    fetchPolicy: 'network-only',
  })
  //liveagents
  useEffect(() => {
    getLanguageIds()
  }, [])
  useEffect(() => {
    let spanishVendor: any = spanishVendors.filter(
      (vendor: any) => vendor.id === data.liveAgentNumberSpanish.vendorId
    )[0]

    if (spanishVendor) {
      setSelectedSpanishVendor(spanishVendor.value)
    }
  }, [data.liveAgentNumberSpanish.vendorId, spanishVendors])
  useEffect(() => {
    let englishVendor: any = englishVendors.filter(
      (vendor: any) => vendor.id === data.liveAgentNumberEnglish.vendorId
    )[0]

    if (englishVendor) {
      setSelectedEnglishVendor(englishVendor.value)
    }
  }, [data.liveAgentNumberEnglish.vendorId, englishVendors])
  useEffect(() => {
    let spanishVendor: any = spanishVendors.filter(
      (vendor: any) => vendor.id === data?.outboundLiveAgentDialInNumberSpn?.vendorId
    )[0]

    if (spanishVendor) {
      setSelectedSpanishVendorOutbound(spanishVendor.value)
    }
  }, [data?.outboundLiveAgentDialInNumberSpn?.vendorId, spanishVendors])
  useEffect(() => {
    let englishVendor: any = englishVendors.filter(
      (vendor: any) => vendor.id === data.outboundLiveAgentDialInNumberEng?.vendorId
    )[0]

    if (englishVendor) {
      setSelectedEnglishVendorOutbound(englishVendor.value)
    }
  }, [data?.outboundLiveAgentDialInNumberEng?.vendorId, englishVendors])
  useEffect(() => {
    if (Boolean(data.liveAgentNumberEnglish.vendorId) && englishIdRef.current) {
      fetchGraphql(callForwardQuery, {
        getVendorForwardingNumberByIdId: data.liveAgentNumberEnglish.vendorId,
        langid: englishIdRef.current,
      }).then(({ data: engForward }) => {
        let vendorNumberEnglish = engForward?.getVendorForwardingNumberById[0]?.vendorNumber
        if (vendorNumberEnglish) {
          updateData({
            liveAgentNumberEnglish: {
              ...data.liveAgentNumberEnglish,
              forwardingNumber: vendorNumberEnglish,
            },
          })
        }
      })
    } else {
      updateData({
        liveAgentNumberEnglish: {
          ...data.liveAgentNumberEnglish,
          forwardingNumber: '',
        },
      })
    }
  }, [data.liveAgentNumberEnglish.vendorId, englishIdRef.current])
  useEffect(() => {
    if (Boolean(data.liveAgentNumberSpanish.vendorId) && spanishIdRef.current) {
      fetchGraphql(callForwardQuery, {
        getVendorForwardingNumberByIdId: data.liveAgentNumberSpanish.vendorId,
        langid: spanishIdRef.current,
      }).then(({ data: spnForward }) => {
        let vendorNumberSpanish = spnForward?.getVendorForwardingNumberById[0]?.vendorNumber
        if (vendorNumberSpanish) {
          updateData({
            liveAgentNumberSpanish: {
              ...data.liveAgentNumberSpanish,
              forwardingNumber: vendorNumberSpanish,
            },
          })
        }
      })
    } else {
      updateData({
        liveAgentNumberSpanish: {
          ...data.liveAgentNumberSpanish,
          forwardingNumber: '',
        },
      })
    }
  }, [data.liveAgentNumberSpanish.vendorId, spanishIdRef.current])

  //Dial in number
  // useEffect(() => {
  //   setdialInNumber(data.clientInfo.dialInNumber)
  // }, [data])

  // useEffect(() => {
  //   setdialInNumber(dialInNumber)
  // }, [dialInNumber])

  // Handling Add
  const handleAdd = () => {
    let dataInfo: any
    dataInfo = data.clientInfo.dialInNumber.filter((admin: any) => {
      if (admin.isDelete && !admin.flag) {
        admin.flag = 1
        return admin
      }
    })
    // the dialInNumber has records of already created
    let list = [...dataInfo] as any
    list = [...list, ...dialInNumber]
    list.push({
      dialInNumber: '',
      position: 0,
      dialInNoError: '',
    })
    setdialInNumber(list)
  }

  // Handling Input Change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: any) => {
    const { name, value } = e.target
    const list = [...dialInNumber] as any
    list[index][name] = value
    let regex = /^[0-9]*$/
    if (!regex.test(list[index].dialInNumber)) {
      list[index]['dialInNoError'] = 'Invalid Dial In Number'
      setEmailDisabled(true)
    } else {
      list[index]['dialInNoError'] = ''
      // setEmailDisabled(false)
    }
    setdialInNumber(list)
    updateData({
      clientInfo: {
        ...data.clientInfo,
        dialInNumber: list,
      },
    })
  }

  const dialInNumberBlur = (e: any, index: any) => {
    let list: any = []
    let regex = /^[0-9]*$/

    const values = [...dialInNumber]
    if (values[index].dialInNumber === '') {
      values[index]['dialInNoError'] = 'Dial In Number is required'
      setdialInNumber(values)
      setEmailDisabled(true)
      // list.push(e.target.value)
    } else if (!regex.test(values[index].dialInNumber)) {
      values[index]['dialInNoError'] = 'Invalid Dial In Number'
      setdialInNumber(values)
      setEmailDisabled(true)
      list.push(e.target.value)
    } else if (values[index].dialInNumber.length !== 10) {
      values[index]['dialInNoError'] = 'Dial In Number should be 10 numbers'
      setdialInNumber(values)
      setEmailDisabled(true)
      list.push(e.target.value)
    } else if (
      values.some(
        (user, index, array) =>
          array.findIndex((u) => u.dialInNumber === user.dialInNumber) !== index
      )
    ) {
      values[index]['dialInNoError'] = 'Duplicate dial in number found'
      setdialInNumber(values)
      setEmailDisabled(true)
      list.push(e.target.value)
    } else {
      values[index]['dialInNoError'] = ''
      setdialInNumber(values)
      // setEmailDisabled(false)
      list.push(e.target.value)
    }

    if (e.target.value.length === 10) {
      if (!apiDialInData.length && !apiDialInData.includes(e.target.value) && e.target.value.length === 10) {
        ; (async () => {
          const response = await dialInValidation({
            variables: {
              numbers: list,
            },
          })

          if (response.data.validateDialInNumbers[0].type === 'NOT_EXISTS') {
            values[index]['dialInNoError'] = ''
          } else if (response.data.validateDialInNumbers[0].type === 'EXISTS') {
            values[index]['dialInNoError'] = 'Dial In Number already exists!'
            setEmailDisabled(true)
          } else {
            values[index]['dialInNoError'] = ''
          }
        })()
      }
    }

    if (values[index]['dialInNoError'] === '') {
      setEmailDisabled(false)
    }
  }

  // // Validation
  const [dialInValidation] = useLazyQuery(VALIDATE_DIAL_IN_NUMBERS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => { },
  })
  // Handling delete
  const handleDelete = (index: any, data1: any) => {
    const list = [...dialInNumber] as any
    let brands
    if (data1.id) {
      brands = data.clientInfo.dialInNumber.map((admin: any) => {
        if (admin.id === data1.id) {
          admin.isDelete = true
        }
        return admin
      })
    }
    list.splice(index, 1)
    setEmailDisabled(false)
    setdialInNumber(list)
  }
  return (
    <>
      <div data-kt-stepper-element='content'>
        <div
          className='w-100'
          style={{ height: '435px', overflowX: 'hidden', overflowY: 'auto', padding: '10px 10px' }}
        >
          <div className='mt-5'>
            <div className='d-flex align-items-center justify-content-between mb-2'>
              <label className=''>
                <span className='fs-6 fw-semibold lh-23 required'>IVR Dial In Number </span>
              </label>
              {/* <button
                type='button'
                className={`btn btn-sm btn-light-primary me-3 fs-6 mt-5 ${
                  emailDisabled && 'disabled'
                }`}
                onMouseDown={() => handleAdd()}
              >
                Add IVR Dial In Number
              </button> */}
            </div>

            {dialInNumber &&
              dialInNumber.map((field: any, i: React.Key | null | undefined) => {
                if (field && !field.isDelete) {
                  return (
                    <>
                      <Row key={i} className='d-flex align-items-start mb-1'>
                        <Col sm={11} md={11}>
                          <div className='d-flex'>
                            <input
                              type='text'
                              value='+1'
                              className='form-control form-control-lg form-control-solid'
                              disabled
                              style={{
                                width: '15%',
                                padding: '7px',
                                borderTopRightRadius: '0px',
                                borderBottomRightRadius: '0px',
                              }}
                            />
                            <input
                              type='text'
                              key={field.id}
                              maxLength={10}
                              className='form-control form-control-lg form-control-solid'
                              name='dialInNumber'
                              placeholder='Enter Dial in number'
                              value={field.dialInNumber}
                              pattern='[0-9]*'
                              onChange={(e) => {
                                handleChange(e, i)
                                dialInNumberBlur(e, i)
                              }}
                            // onBlur={(e)=> dialInNumberBlur(e,i)}
                            />
                          </div>
                        </Col>
                        {i != 0 && (
                          <Col sm={1} md={1} className='p-0 mt-2'>
                            <img
                              src={deleteButton}
                              alt='delete'
                              onClick={() => handleDelete(i, field)}
                              className='pointer'
                            />
                          </Col>
                        )}
                        <Row>
                          <div className='text-danger mb-5' style={{ position: 'relative' }}>
                            {data.clientInfo?.dialInNumber && field.dialInNoError && (
                              <div
                                data-field='appname'
                                data-validator='notEmpty'
                                className='fv-help-block'
                              >
                                {field.dialInNoError}
                              </div>
                            )}
                          </div>
                        </Row>
                      </Row>
                    </>
                  )
                }
              })}
            <Row>
              <div className='fv-plugins-message-container' style={{ position: 'relative' }}>
                {data.clientInfo?.dialInNumber && dialInNoValidation && (
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {dialInNoValidation}
                  </div>
                )}
              </div>
            </Row>
          </div>
          {/* <div className='fs-6 fw-semibold required mb-5'>Live Agent Dial</div> */}
          <div style={{ padding: '15px', boxShadow: '0px 0px 9px #c9c9c9', marginBottom: '15px' }}>
            <label
              className={`fs-6 fw-semibold mb-5 ${data?.clientSettings.liveAgents ? 'required' : ''
                }`}
            >
              Live Agent Dial In Number for English
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '15%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='number'
                maxLength={10}
                className='form-control form-control-lg form-control-solid'
                name='LiveagentdialInNumber'
                placeholder='Enter Live Agent Dial in number'
                value={data.liveAgentNumberEnglish.liveAgentDialInNumber}
                pattern='[0-9]*'
                onChange={(e) => {
                  if (e.target.value.length < 11) {
                    updateData({
                      liveAgentNumberEnglish: {
                        ...data.liveAgentNumberEnglish,
                        liveAgentDialInNumber: e.target.value,
                      },
                    })
                  }
                }}
              // onBlur={(e)=> dialInNumberBlur(e,i)}
              />
            </div>
            {hasError &&
              data?.clientSettings.liveAgents &&
              !Boolean(data?.liveAgentNumberEnglish?.liveAgentDialInNumber) ? (
              <div className='text-danger'>Live agent dial in number for English is required</div>
            ) : (
              data?.liveAgentNumberEnglish?.liveAgentDialInNumber?.length !== 10 &&
              data?.liveAgentNumberEnglish?.liveAgentDialInNumber?.length > 0 && (
                <div className='text-danger'>Invalid dial in number</div>
              )
            )}

            <div className='d-flex align-items-center justify-content-between mb-4'>
              <div className='min-w-175px me-3 mt-3'>
                <label>Select Vendor</label>
                <Dropdown
                  fieldName='englishVendor'
                  optionList={englishVendors}
                  handleSelectedItem={(value: any) => {
                    setSelectedEnglishVendor(value)
                    updateData({
                      liveAgentNumberEnglish: {
                        ...data.liveAgentNumberEnglish,
                        vendorId: value.value,
                      },
                    })
                  }}
                  selectedVal={selectedEnglishVendor}
                />
                {hasError &&
                  data?.clientSettings.liveAgents &&
                  !Boolean(data?.liveAgentNumberEnglish?.vendorId) && (
                    <div className='text-danger'>Vendor is required</div>
                  )}
              </div>
              <div className='mt-3'>
                <label>Call forwarding Number</label>
                <div className='d-flex'>
                  <input
                    type='text'
                    value='+1'
                    className='form-control form-control-lg form-control-solid'
                    disabled
                    style={{
                      width: '25%',
                      padding: '7px',
                      borderTopRightRadius: '0px',
                      borderBottomRightRadius: '0px',
                    }}
                  />
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    name='LiveagentdialInNumber'
                    placeholder='Call forward Number'
                    value={data.liveAgentNumberEnglish.forwardingNumber}
                    disabled={true}
                  />
                </div>
                {hasError &&
                  data?.clientSettings.liveAgents &&
                  !Boolean(data?.liveAgentNumberEnglish?.forwardingNumber) && (
                    <div className='text-danger'>Forwarding number is required</div>
                  )}
              </div>
            </div>
          </div>
          <div style={{ padding: '15px', boxShadow: '0px 0px 9px #c9c9c9' }}>
            <label
              className={`fs-6 fw-semibold ${data?.clientSettings.liveAgents ? 'required' : ''
                } mb-5`}
            >
              Live Agent Dial In Number for Spanish
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '15%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='text'
                maxLength={10}
                className='form-control form-control-lg form-control-solid'
                name='LiveagentdialInNumber'
                placeholder='Enter Live Agent Dial in number'
                value={data.liveAgentNumberSpanish.liveAgentDialInNumber}
                pattern='[0-9]*'
                onChange={(e) => {
                  if (e.target.value.length < 11) {
                    updateData({
                      liveAgentNumberSpanish: {
                        ...data.liveAgentNumberSpanish,
                        liveAgentDialInNumber: e.target.value,
                      },
                    })
                  }

                  // handleChange(e, i)
                  // dialInNumberBlur(e, i)
                }}
              // onBlur={(e)=> dialInNumberBlur(e,i)}
              />
            </div>
            {hasError &&
              data?.clientSettings.liveAgents &&
              !Boolean(data?.liveAgentNumberSpanish?.liveAgentDialInNumber) ? (
              <div className='text-danger'>Live agent dial in number for Spanish is required</div>
            ) : (
              data?.liveAgentNumberSpanish?.liveAgentDialInNumber?.length !== 10 &&
              data?.liveAgentNumberSpanish?.liveAgentDialInNumber?.length > 0 && (
                <div className='text-danger'>Invalid dial in number</div>
              )
            )}

            <div className='d-flex align-items-center justify-content-between mb-4'>
              <div className='min-w-175px me-3 mt-3'>
                <label>Select Vendor</label>
                <Dropdown
                  fieldName='spanishVendor'
                  optionList={spanishVendors}
                  handleSelectedItem={(value: any) => {
                    setSelectedSpanishVendor(value)
                    updateData({
                      liveAgentNumberSpanish: {
                        ...data.liveAgentNumberSpanish,
                        vendorId: value.value,
                      },
                    })
                  }}
                  selectedVal={selectedSpanishVendor}
                />
                {hasError &&
                  data?.clientSettings.liveAgents &&
                  !Boolean(data?.liveAgentNumberSpanish?.vendorId) && (
                    <div className='text-danger'>Vendor is required</div>
                  )}
              </div>
              <div className='mt-3'>
                <label>Call forwarding Number</label>
                <div className='d-flex'>
                  <input
                    type='text'
                    value='+1'
                    className='form-control form-control-lg form-control-solid'
                    disabled
                    style={{
                      width: '25%',
                      padding: '7px',
                      borderTopRightRadius: '0px',
                      borderBottomRightRadius: '0px',
                    }}
                  />
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    name='LiveagentdialInNumber'
                    placeholder='Call forward Number'
                    value={data.liveAgentNumberSpanish.forwardingNumber}
                    disabled={true}
                  />
                </div>
                {hasError &&
                  data?.clientSettings.liveAgents &&
                  !Boolean(data?.liveAgentNumberSpanish?.forwardingNumber) && (
                    <div className='text-danger'>Forwarding number is required</div>
                  )}
              </div>
            </div>
          </div>
          <div className='my-4' style={{ padding: '15px', boxShadow: '0px 0px 9px #c9c9c9' }}>
            <label
              className={`fs-6 fw-semibold ${data?.clientSettings.outboundLiveAgent ? 'required' : ''
                } mb-5`}
            >
              Outbound Live Agent Dial In Number for English
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '15%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='text'
                maxLength={10}
                className='form-control form-control-lg form-control-solid'
                name='LiveagentdialInNumber'
                placeholder='Enter Live Agent Dial in number'
                value={data?.outboundLiveAgentDialInNumberEng?.liveAgentDialInNumber}
                pattern='[0-9]*'
                onChange={(e) => {
                  if (e.target.value.length < 11) {
                    updateData({
                      outboundLiveAgentDialInNumberEng: {
                        ...data?.outboundLiveAgentDialInNumberEng,
                        liveAgentDialInNumber: e.target.value,
                      },
                    })
                  }

                  // handleChange(e, i)
                  // dialInNumberBlur(e, i)
                }}
              // onBlur={(e)=> dialInNumberBlur(e,i)}
              />
            </div>
            <div className='min-w-175px me-3 mt-3'>
              <label>Select Vendor</label>
              <Dropdown
                fieldName='englishVendor'
                optionList={englishVendors}
                handleSelectedItem={(value: any) => {
                  setSelectedEnglishVendorOutbound(value)
                  updateData({
                    outboundLiveAgentDialInNumberEng: {
                      ...data?.outboundLiveAgentDialInNumberEng,
                      vendorId: value.value,
                    },
                  })
                }}
                selectedVal={selectedEnglishVendorOutbound}
              />
            </div>
            <label
              className={`fs-6 fw-semibold mt-3 ${data?.clientSettings.outboundLiveAgent ? 'required' : ''
                } mb-5`}
            >
              Outbound Live Agent Dial In Number for Spanish
            </label>
            <div className='d-flex'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid'
                disabled
                style={{
                  width: '15%',
                  padding: '7px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              />
              <input
                type='text'
                maxLength={10}
                className='form-control form-control-lg form-control-solid'
                name='LiveagentdialInNumber'
                placeholder='Enter Live Agent Dial in number'
                value={data?.outboundLiveAgentDialInNumberSpn?.liveAgentDialInNumber}
                pattern='[0-9]*'
                onChange={(e) => {
                  if (e.target.value.length < 11) {
                    updateData({
                      outboundLiveAgentDialInNumberSpn: {
                        ...data?.outboundLiveAgentDialInNumberSpn,
                        liveAgentDialInNumber: e.target.value,
                      },
                    })
                  }

                  // handleChange(e, i)
                  // dialInNumberBlur(e, i)
                }}
              // onBlur={(e)=> dialInNumberBlur(e,i)}
              />
            </div>
            <div className='min-w-175px me-3 mt-3'>
              <label>Select Vendor</label>
              <Dropdown
                fieldName='spanishVendor'
                optionList={spanishVendors}
                handleSelectedItem={(value: any) => {
                  setSelectedSpanishVendorOutbound(value)
                  updateData({
                    outboundLiveAgentDialInNumberSpn: {
                      ...data?.outboundLiveAgentDialInNumberSpn,
                      vendorId: value.value,
                    },
                  })
                }}
                selectedVal={selectedSpanishVendorOutbound}
              />
            </div>
          </div>

          {/* <div className='fs-6 fw-semibold required mb-5'>Vendor Call forwarding numbers</div> */}

          {/* <Dropdown
                fieldName='State'
                optionList={[
                  {id: '1', value: 'English'},
                  {id: '2', value: 'Spanish'},
                ]}
                handleSelectedItem={(value: any) => console.log(value)}
                selectedVal={{id: '1', value: 'English'}}
                data={''}
              /> */}
        </div>
      </div>
    </>
  )
}
export { Step5 }
